var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-8"},[_c('block-accident-details',{attrs:{"details":_vm.accident.details}})],1),_c('div',{staticClass:"col-md-4"},[_c('block-accident-towing',{attrs:{"towing":_vm.accident.towing}})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }